export const alterServices = (origin) =>
  origin.map((item) => {
    item.trip_id_before = item.trip_id;
    if (item.product_id_field === 'service_id') {
      item.trip_id = Number(item.product_id);
    }
    return item;
  });

export const isServiceField = ({ departureSegmentId, allServices }) =>
  allServices[departureSegmentId]?.[0]?.product_id_field === 'service_id';

export const isRepeatableStop = ({ routeId = '', allRoutes }) =>
  allRoutes?.[routeId].repeatable_route_stops === true;

export const alterTripField = (serviceField, origin) => {
  if (origin && serviceField) {
    return {
      ...origin,
      trip_id: undefined,
      trip_id_before: undefined,
      service_id: origin.trip_id,
    };
  }
  return { ...origin, trip_id_before: undefined };
};
